import {
    IdCard,
    Edit,
    PhoneCall,
} from "lucide-react";
import {Link} from "@inertiajs/react";
import {
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardContent,
} from "@/components/ui/card";

interface Props {
    patient: any;
    translations?: any;
    onEdit?: (patient: any) => void;
}

export function MobilePatientCard({patient, translations: t, onEdit}: Props) {
    const recordNumber = patient.patient_card?.record_number ?? "-";
    const cardId = patient.patient_card?.id;

    return (
        <Card className="w-full">
            <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                    <div className="min-w-0">
                        <CardTitle className="text-base truncate">
                            {patient.name}
                        </CardTitle>
                        <CardDescription className="truncate">
                            {patient.city ?? "-"}
                        </CardDescription>
                    </div>

                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            className="p-2 rounded-md hover:bg-muted"
                            onClick={() => onEdit?.(patient)}
                        >
                            <Edit className="w-4 h-4"/>
                        </button>

                        {cardId && (
                            <Link
                                href={`/patient_cards/${cardId}`}
                                target="_blank"
                                className="p-2 rounded-md hover:bg-muted"
                            >
                                <IdCard className="w-4 h-4"/>
                            </Link>
                        )}
                    </div>
                </div>
            </CardHeader>

            <CardContent className="space-y-4 text-sm">

                <div className="grid grid-cols-2 gap-3">
                    <Info label={t?.table_record_number} value={recordNumber}/>
                    <Info label={t?.table_phone} value={patient.phone_number ?? "-"}/>
                    <Info label={t?.table_year_of_birth} value={patient.year_of_birth ?? "-"}/>

                    <div>
                        <div className="text-muted-foreground text-xs">
                            {t?.table_call_before}
                        </div>
                        {patient.call_before_appointment ? (
                            <PhoneCall className="w-4 h-4 mt-1"/>
                        ) : (
                            <div className="text-muted-foreground">-</div>
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <div className="min-w-0">
                        <div className="text-muted-foreground text-xs">
                            {t?.table_doctor}
                        </div>
                        {patient.doctor ? (
                            <div className="flex items-center gap-2 truncate">
                <span
                    className="w-3 h-3 rounded-full shrink-0"
                    style={{backgroundColor: patient.doctor.color ?? "#ddd"}}
                />
                                <span className="truncate">
                  {patient.doctor.name}
                </span>
                            </div>
                        ) : (
                            "-"
                        )}
                    </div>

                    <Info
                        label={t?.table_orthodontics}
                        value={patient.orthodontics ? "Da" : "Ne"}
                    />
                </div>

                <Info
                    label={t?.table_orthodontist}
                    value={
                        patient.orthodontics && patient.orthodontist
                            ? patient.orthodontist.name
                            : "-"
                    }
                />

                <div>
                    <div className="text-muted-foreground text-xs">
                        {t?.table_owes_money}
                    </div>
                    {patient.owes_money ? (
                        <span className="font-medium">Da</span>
                    ) : (
                        <span className="text-sm text-muted-foreground">Ne</span>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}

function Info({label, value}: { label?: string; value: any }) {
    return (
        <div className="min-w-0">
            <div className="text-muted-foreground text-xs">{label}</div>
            <div className="truncate">{value}</div>
        </div>
    );
}